<template>
  <div class="wifi-config">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>WiFi配置历史</span>
          <el-select v-model="selectedDevice" placeholder="选择设备" @change="loadConfigHistory">
            <el-option
              v-for="device in devices"
              :key="device.device_id"
              :label="device.name || device.device_id"
              :value="device.device_id">
            </el-option>
          </el-select>
        </div>
      </template>

      <el-table :data="configHistory" style="width: 100%">
        <el-table-column prop="ssid" label="SSID" width="180"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag :type="scope.row.status === 'success' ? 'success' : 'danger'">
              {{ scope.row.status === 'success' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ip_address" label="IP地址"></el-table-column>
        <el-table-column prop="connected_at" label="连接时间"></el-table-column>
        <el-table-column prop="disconnected_at" label="断开时间"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

export default {
  name: 'WifiConfig',
  setup() {
    const devices = ref([])
    const selectedDevice = ref('')
    const configHistory = ref([])

    const getDevices = async () => {
      try {
        const response = await axios.get('/api/devices.php')
        devices.value = response.data
      } catch (error) {
        ElMessage.error('获取设备列表失败')
      }
    }

    const loadConfigHistory = async () => {
      if (!selectedDevice.value) return

      try {
        const response = await axios.get(`/api/wifi_config.php?device_id=${selectedDevice.value}`)
        configHistory.value = response.data
      } catch (error) {
        ElMessage.error('获取配置历史失败')
      }
    }

    onMounted(() => {
      getDevices()
    })

    return {
      devices,
      selectedDevice,
      configHistory,
      loadConfigHistory
    }
  }
}
</script>

<style scoped>
.wifi-config {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-select {
  width: 200px;
}
</style> 